import React, { ReactElement } from "react";
import Link from "next/link";
import styles from "./logoGroup.module.scss";
import { trackEvent } from "@kunduz/utility-analytics";

export const LogoGroup = (props: Props): ReactElement => {
  const BadgeIcon = props.badgeIcon;
  const PrimaryCtaIcon = props.primary_cta_icon!;
  const SecondaryCtaIcon = props.secondary_cta_icon!;

  function getCorrectButtonStyle(type?: string) {
    switch (type) {
      case "primary":
        return styles.primaryButton;
      case "secondary":
        return styles.secondaryButton;
      case "tertiary":
        return styles.tertiaryButton;
      case "link":
        return styles.linkButton;

      default:
        return styles.primaryButton;
    }
  }

  function handleClicked(label?: string) {
    trackEvent("Collaboration Component CTA Button Clicked", {
      componentName: props.name,
      label,
    });
  }

  return (
    <section className={styles.base}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.heading}>
            <div className={styles.top}>
              <div className={styles.badge}>
                <BadgeIcon color="#98a2b3" />
                <span className={styles.badgeText}>{props.badgeText}</span>
              </div>
              <div className={styles.headingText}>{props.title}</div>
            </div>
            <div className={styles.supportingText}>{props.supportingText}</div>
          </div>
          <div className={styles.actions}>
            {props.secondary_cta_url && props.secondary_cta_label && (
              <Link
                className={getCorrectButtonStyle(props.secondary_cta_type)}
                href={props.secondary_cta_url}
                target={props.secondary_cta_target || "_self"}
                onClick={() => handleClicked(props.secondary_cta_label)}
              >
                {props.secondary_cta_icon && (
                  <SecondaryCtaIcon viewBox="0 0 24 24" />
                )}
                {props.secondary_cta_label}
              </Link>
            )}
            {props.primary_cta_url && props.primary_cta_label && (
              <Link
                className={getCorrectButtonStyle(props.primary_cta_type)}
                href={props.primary_cta_url}
                target={props.primary_cta_target || "_self"}
                onClick={() => handleClicked(props.primary_cta_label)}
              >
                {props.primary_cta_icon && (
                  <PrimaryCtaIcon viewBox="0 0 24 24" />
                )}
                {props.primary_cta_label}
              </Link>
            )}
          </div>
        </div>
        <div className={styles.logos}>
          {props.logoUrls?.map((url, i) => (
            <img src={url} key={i} alt="" height={32} loading="lazy" />
          ))}
        </div>
      </div>
    </section>
  );
};

interface Props {
  name: string;
  badgeText: string;
  badgeIcon: React.ElementType;
  title: string;
  supportingText: string;
  logoUrls: string[];
  primary_cta_label?: string;
  primary_cta_url?: string;
  primary_cta_icon?: React.ElementType;
  primary_cta_type?: string;
  primary_cta_target?: string;
  secondary_cta_label?: string;
  secondary_cta_url?: string;
  secondary_cta_icon?: React.ElementType;
  secondary_cta_type?: string;
  secondary_cta_target?: string;
}
